import { render, staticRenderFns } from "./IbMainNavigation.vue?vue&type=template&id=ea2c5bb0&scoped=true"
import script from "./IbMainNavigation.vue?vue&type=script&lang=js"
export * from "./IbMainNavigation.vue?vue&type=script&lang=js"
import style0 from "./IbMainNavigation.vue?vue&type=style&index=0&id=ea2c5bb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea2c5bb0",
  null
  
)

export default component.exports